<modal>
  <div header class="uppercase">{{title}}</div>
  <text-filter [target]="payments" [placeholder]="'Tìm kiếm'" class="std-margin-bottom"></text-filter>
  <table responsive class="data">
    <tr>
      <th class="text-top text-right" style="width: 0">STT</th>
      <th class="text-top">{{'Thời gian' | lang}}</th>
      <th class="text-top">{{'Đối tượng' | lang}}</th>
      <th class="text-top">{{'Nội dung' | lang}}</th>
      <th class="text-top text-right">{{'Số tiền' | lang}}</th>
    </tr>
    <tr *ngFor="let i of payments.pageMatches; index as ix">
      <td><small>{{ix + 1 + payments.pageIndex * payments.pageSize}}</small></td>
      <td>
        <div class="spacy">{{i.Stamp | date : 'dd-MM-yyyy'}}</div>
      </td>
      <td>
        <span class="uppercase bold" [ngClass]="{'text-success' : i.Type == 4, 'text-warning': i.Type == 8}">{{name(i)}}</span>
        <br />
        <small class="uppercase">{{group(i)}}</small>
      </td>
      <td><elipsis>{{i.Notes}}</elipsis></td>
      <td>
        <number [sign]="false" [good]="'positive'" [decimal]="0" [value]="i.Amount"></number><vnd></vnd>
      </td>
    </tr>
    <tr *ngIf="payments.pages.length > 1">
      <td class="hidden"></td>
      <td [colSpan]="5" class="text-center"><pagination [target]="payments"></pagination></td>
    </tr>
    <tr class="footer" *ngIf="payments.matches.length > 1">
      <td></td>
      <td><b>{{'TỔNG' | lang}} ({{payments.matches.length}})</b></td>
      <td></td>
      <td></td>
      <td><number class="bold" [sign]="false" [good]="'positive'" [decimal]="0" [value]="sum"></number><vnd></vnd></td>
    </tr>
  </table>
</modal>
